import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=5c95b46b&scoped=true"
import script from "./Menus.vue?vue&type=script&lang=js"
export * from "./Menus.vue?vue&type=script&lang=js"
import style0 from "./Menus.vue?vue&type=style&index=0&id=5c95b46b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95b46b",
  null
  
)

export default component.exports